import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IDiscountRule } from "@pbm/discount-rules/contracts/discount-rule";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { CursorPaginated } from "@types";

export function useDiscountRules(
  programCode: string,
  programFamilyCode: string
) {
  const { request } = usePbm2Url();
  return useQuery(
    `discountRules:${programCode}:${programFamilyCode}`,
    async () => {
      const { Rules_discountRules } = await request(
        gql`
          query ($programCode: String!, $programFamilyCode: String!) {
            Rules_discountRules(
              filter: {
                programCode: [$programCode]
                programFamilyCode: [$programFamilyCode]
              }
            ) {
              pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
                pageCount
                totalCount
              }
              edges {
                cursor
                node {
                  id
                  type
                  monthlyLimit
                  createdAt
                  updatedAt
                  effectiveSince
                  effectiveUntil
                  accountedProducts {
                    ean
                    name
                    package
                  }
                  discountedProducts {
                    ean
                    name
                    package
                  }
                  ranges {
                    saleDiscountPercentage
                    boxesFrom
                    boxesTo
                    daysBetweenSalesInterval
                    daysWithoutSalesTolerance
                  }
                }
              }
            }
          }
        `,
        { programCode, programFamilyCode }
      );
      return Rules_discountRules as CursorPaginated<IDiscountRule>;
    }
  );
}
